module.exports = __webpack_public_path__ + "f9eb4ff5f28d6aebfa1ddf5e9cab469d.png";